<template>
  <div>
    <div v-for="(newProperty, index) in newProperties" :key="'property'+index" class="row" style="border-bottom: 1px solid #f0f0f0">
      <div class="col-10" style="font-size: .9em">
        {{ newProperty }}
      </div>
      <div class="col-2 text-end">
        <button class="btn btn-sm btn-danger" @click.stop="() => $emit('removeProperty', index)">
          <i class="fa fa-trash" />
        </button>
      </div>
    </div>

    <!-- Placeholder for a new one -->
    <order-geometry-property-selector
      ref="orderGeometryPropertySelector"
      :large-mode="true"
      class="mt-3"
      @add-property="(newProperty) => $emit('addProperty', newProperty)"
    />
  </div>
</template>

<script>
import OrderGeometryPropertySelector from "./OrderGeometryPropertySelector";
export default {
    name: "OrderGeometryPropertyEditor",
    components: {OrderGeometryPropertySelector},
    props: {
        newProperties: {
            type: Array,
            default: () => ([])
        },
    },
    methods: {
        reset() {
            this.$refs.orderGeometryPropertySelector.reset();
        }
    }
}
</script>
